import Alpine from 'alpinejs'

Alpine.data('videoPlayerMp4', () => ({
    
    isPlaying: false,
    isMuted: false,
    
    init() {
        this.$watch('isPlaying', value => {
            this.$dispatch(value ? 'video-started' : 'video-stopped')
        })
        this.$watch('isMuted', (value, before) => {
            if(value !== before) {
                this.$dispatch(value ? 'video-muted' : 'video-unmuted')
            }
        })
        this.$refs.video.addEventListener('play', () => {
            this.isPlaying = true
        })
        this.$refs.video.addEventListener('pause', () => {
            this.isPlaying = false
        })
        this.$refs.video.addEventListener('ended', () => {
            this.isPlaying = false
        })
        this.$refs.video.addEventListener('volumechange', event => {
            this.isMuted = event.target.muted || event.target.volume === 0
        })
    },
    
    start() {
        this.$refs.video.play()
    },
    stop() {
        this.$refs.video.pause()
    },
    toggle() {
        if(this.isPlaying) {
            this.stop()
        } else {
            this.start()
        }
    },
}))